import { gql, useQuery } from '@apollo/client'

const GET_LENDER_CONFIG = gql`
  query getLenderConfig($vertical: V2VerticalTypeGqlEnum!) {
    getLenderConfig(vertical: $vertical) {
      slug
      name
      loanTerms
      rateSlug
      minLoanTerm
      maxLoanTerm
      minLoanAmount
      maxLoanAmount
      minCreditScore
      displayFixedRates
      displayVariableRates
      eligibleDegrees
      lenderDirectUrl
      enableDirectUrl
    }
  }
`

const useActiveLenders = (vertical) => {
  const { data } = useQuery(GET_LENDER_CONFIG, {
    variables: { vertical },
  })

  return data ? data.getLenderConfig : []
}

export default useActiveLenders
